import makeApiCall from "./axiosIndex";
const gateEntryApis = {
  gateEntryTypesList: async (): Promise<any> => {
    return makeApiCall({
      url: "/masters/gateEntryTypesList",
      method: "get",
    });
  },

  fetchGateEntryWithPagination: (params: any): Promise<any> => {
    return makeApiCall({
      url: "/buyer/fetchGateEntriesWithPagination",
      method: "get",
      params,
    });
  },

  fetchGateEntryDropDown: (): Promise<any> => {
    return makeApiCall({
      url: "/buyer/fetchGateEntryDropDown",
      method: "get",
    });
  },

  fetchGateEntryById: (id: number): Promise<any> => {
    return makeApiCall({
      url: `/buyer/fetchGateEntryById`,
      method: "get",
      params: { id },
    });
  },

  updateGateEntryById: (id: number, data: any): Promise<any> => {
    return makeApiCall({
      url: `/buyer/updateGateEntryById`,
      method: "put",
      params: { id },
      data,
    });
  },

  createGateEntry: (data: any): Promise<any> => {
    return makeApiCall({
      url: `/buyer/createGateEntry`,
      method: "post",
      data,
    });
  },

  deleteGateEntryById: (id: number): Promise<any> => {
    return makeApiCall({
      url: "/buyer/deleteGateEntryById",
      method: "delete",
      params: { id },
    });
  },

  deleteGateEntriesByIds: (ids: number[]): Promise<any> => {
    return makeApiCall({
      url: "/buyer/deleteGateEntriesByIds",
      method: "delete",
      data: { ids },
    });
  },

  // status
  allowActiveStatus: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "patch",
      url: `/buyer/activateGateEntryById`,
      params: { id },
    }),

  activateGateEntriesByIds: (ids: number[]): Promise<any> => {
    return makeApiCall({
      url: "/buyer/activateGateEntriesByIds",
      method: "put",
      data: { ids },
    });
  },

  removeActiveStatus: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "patch",
      url: `/buyer/inActivateGateEntryById`,
      params: { id },
    }),

  inactivateGateEntriesByIds: (ids: number[]): Promise<any> => {
    return makeApiCall({
      url: "/buyer/inactivateGateEntriesByIds",
      method: "put",
      data: { ids },
    });
  },
};

export default gateEntryApis;

